import React from 'react';
import PropTypes from 'prop-types';
import { Input as RInput } from 'reactstrap';
import { useField } from 'formik';
import useOnUnmount from './useOnUnmount';

const Input = (props) => {
  const { name, plaintext, invalid, readOnly, children, onUnmount, ...other } = props;
  const [field, meta] = useField(name);

  useOnUnmount(props);

  return plaintext ? (
    <RInput value={field.value || ''} disabled />
  ) : (
    <RInput
      {...field}
      value={field.value || ''}
      invalid={(meta.error && meta.touched) || props.invalid}
      id={name}
      disabled={readOnly}
      {...other}
    >
      {children}`
    </RInput>
  );
};
Input.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf([
    'text',
    'email',
    'select',
    'file',
    'radio',
    'checkbox',
    'textarea',
    'button',
    'reset',
    'submit',
    'date',
    'datetime-local',
    'hidden',
    'image',
    'month',
    'number',
    'range',
    'search',
    'tel',
    'url',
    'week',
    'password',
    'datetime',
    'time',
    'color',
  ]),
  bsSize: PropTypes.oneOf(['lg', 'sm']),
  plaintext: PropTypes.bool,
  invalid: PropTypes.bool,
  onUnmount: PropTypes.func,
};

export default Input;
